export default __webpack_public_path__ + "static/media/gayle-modal.00efff5c.jpg";